export enum UserRoles {
  ADMIN = 'ADMIN',
  USER = 'USER',
  MEMBER = 'MEMBER',
  ORGANIZATION = 'ORGANIZATION',
}
